<template>
    <div
        class="page-container page-container--height chat-visible"
        v-if="loggedIn"
        :class="{'sidebar-collapsed--chat' : sidebarStateRight, 'sidebar-collapsed' : sidebarStateLeft}"
    >
        <app-left-panel></app-left-panel>

        <div class="main-content main-content--wide">

            <div class="row--header">
                <app-common-header></app-common-header>
            </div>
            <hr class="separator" />

            <app-messages-dashboard></app-messages-dashboard>

        </div>

<!--        <app-right-panel v-if="$route.name !== 'dashboard'"></app-right-panel>-->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import LeftPanel from './LeftPanel.vue';
    // import RightPanel from './RightPanel.vue';
    import ProfileForm from '../../common_components/ProfileForm.vue';
    import MessagesDashboard from './MessagesDashboard';
    import env from '../../env';
    import MoodleLoginForm from "../../common_components/MoodleLoginForm";
    import Header from "../../common_components/Header";

    export default {
        data: () => ({
            env,
            blocker: false
        }),
        computed: {
            ...mapGetters([
                'loggedInHash',
                'loggedIn',
                'sidebarStateLeft',
                'sidebarStateRight',
                'dashboard',
                'userData',
                'chatsAll'
            ]),
            unreadMessages() {
                let result = 0;
                this.dashboard.data.forEach(item => {
                    result += item.unread_messages_count
                });
                return result;
            }
        },
        components: {
            appLeftPanel: LeftPanel,
            // appRightPanel: RightPanel,
            appProfileForm: ProfileForm,
            appMessagesDashboard: MessagesDashboard,
            appMoodleLoginForm: MoodleLoginForm,
            appCommonHeader: Header
        },
        watch: {
            loggedInHash: function (val) {
                if(!this.loggedIn){
                    this.$router.push({ name: 'login' });
                }
            },
            chatsAll(val) {
                if(val && !this.blocker) {
                    this.blocker = true;
                    this.$store.dispatch('getAllUsers');
                }
            }
        },
        created() {
            this.$store.dispatch('getDashboardData');

            this.$store.commit('SET_PREFIX', true);
        },
        destroyed() {
            this.$store.commit('SET_PREFIX', false);
        },
    }
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .page-container.sidebar-collapsed {
    background-color: #fff;

    & ::v-deep .sidebar-menu {
      width: auto;
      min-width: auto;

      .logo-env > div.sidebar-collapse {
        left: 0;
      }

      #main-menu > li > a span {
        display: none;
      }
    }

    & ::v-deep .aside-menu__icon {
      margin-right: 0;
    }
    
    .main-content--wide {
      width: calc(100% - 65px) !important;
      margin-left: 65px;
    }
  }
}
</style>
